import React from 'react';
import {Divider} from 'antd';
import { Link } from 'dva/router';
import LinesEllipsis from 'react-lines-ellipsis';

export default ({novel_id, name, pic, author, cata, brief}) => (
<div style={{
    height: '77px',
}}>
    <Link to={`/book/detail/${novel_id}`}>
        <img alt='' src={pic} style={{
            height: '77px',
            width: '60px',
            float: 'left',
        }}/>
        <div style={{
            position: 'relative',
            marginLeft: '70px',
        }}>
            <div style={{
                position: 'absolute',
                top: '3px',
                fontSize: '16px',
                lineHeight: '22px',
                color: '#333333',
                maxWidth: '180px',
            }}>
				<LinesEllipsis text={name} maxLine={1} />
            </div>
            <div style={{
                position: 'absolute',
                top: '35px',
                fontSize: '14px',
                lineHeight: '20px',
                color: '#999999',
            }}>
				<LinesEllipsis text={brief} maxLine={2} />
            </div>
            <div style={{
                position: 'absolute',
                top: '3px',
                right: '0px',
                fontSize: '12px',
                lineHeight: '17px',
                color: '#999999',
            }}>
            {cata}<Divider type="vertical" />{author}
            </div>
        </div>
    </Link>
</div>
)



// WEBPACK FOOTER //
// ./src/component/book/styl_brief_1.js